module.exports = __webpack_public_path__ + "static/media/bytt-no-8.d5d25d62.mp3";